module.exports = __webpack_public_path__ + "static/media/camilla-magela.c909fc35.jpg";